import { Component, Input } from '@angular/core';

import { IAtxScrollSpy } from '../interfaces';

@Component({
    selector: 'atx-scroll-spy',
    template: `<div class="col-4">
    <nav id="navbar-example3" class="navbar navbar-light bg-light flex-column">
        <a class="navbar-brand" href="#">Navbar</a>
        <nav class="nav nav-pills flex-column">
            <a class="nav-link"
               *ngFor="let element of model; let index = index"
               href="#list-item-{{ index }}">
                {{ element?.label }}
            </a>
        </nav>
    </nav>
</div>

<div class="col-8">
    <div data-spy="scroll" data-target="#navbar-example3" data-offset="0" class="scrollspy-example-2">
        <div *ngFor="let element of model; let index = index"
             id="list-item-{{ index }}">
            <h3>{{ element?.label }}</h3>
            <p [innerHTML]="element?.content"></p>
        </div>
    </div>
</div>
`,
    styles: [``],
})

export class AtxScrollSpyComponent {
    @Input() public readonly model: IAtxScrollSpy[];
}
